import React, { useEffect, useCallback } from 'react';

import { Stack, IconButton, ActionBar, CloseIcon } from '@gogame/components';
import { withForm, FormField } from '@gogame/form';
import { useScreenDispatch } from '@gogame/screens';

import { SET_COHORTS_SETTINGS } from 'scenes/Trackers/Tracker/reducers';
import { loadCohortsMetricList } from 'scenes/Trackers/Tracker/sources/metrics';
import { useCurrentDimension } from 'scenes/Trackers/hooks';

const METRIC = 'metric';

const CohortSettings = withForm({
  enableReinitialize: true,
})(({ values, onClose }) => {
  const dispatch = useScreenDispatch();
  const dimension = useCurrentDimension();

  const handleLoadDimension = useCallback(
    () => loadCohortsMetricList({ dimension }),
    [dimension]
  );

  const handleClose = () => {
    dispatch({
      type: SET_COHORTS_SETTINGS,
      payload: { [METRIC]: '' },
    });
    onClose();
  };

  useEffect(() => {
    if (values[METRIC]) {
      dispatch({
        type: SET_COHORTS_SETTINGS,
        payload: values,
      });
    }
  }, [values]);

  return (
    <ActionBar>
      <Stack
        spacing={2}
        alignItems={'center'}
        justifyContent={'flex-end'}
        direction={'row'}
      >
        <FormField.Select
          name={METRIC}
          source={handleLoadDimension}
          label={'View as cohorts'}
          width={'208px'}
          dropdownWidth={352}
          dropdownAlign={'right'}
          padding={0}
        />
        <IconButton
          icon={<CloseIcon />}
          tooltip={'Close'}
          onClick={handleClose}
        />
      </Stack>
    </ActionBar>
  );
});
CohortSettings.displayName = 'CohortSettings';
export default CohortSettings;
